<template>
  <div class="rounded p-3" style="background: #a8b5c1">
    <div style="max-width: 100%; margin: 0 auto; position: relative">
      <div style="display: flex; height: 910px; position: relative">
        <!-- Left Sidebar (Outside - Gray Area) -->
        <div
          id="leftSidebarAreaBM"
          style="
            width: 14%;
            background: #b8c5d1;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          "
        >
          <span
            v-if="!banner"
            class="text-muted small text-center"
            style="
              writing-mode: vertical-rl;
              transform: rotate(180deg);
              font-size: 10px;
            "
            >Left Sidebar<br />220x600px</span
          >
          <div
            id="leftSidebarOverlayBM"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 5;
            "
          >
            <img
              v-if="banner && banner.key === 'left' && banner.previewUrl"
              :src="banner.previewUrl"
              alt="Left Sidebar"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>
        </div>

        <!-- Center Website Content -->
        <div
          style="
            flex: 1;
            background: #fff;
            position: relative;
            display: flex;
            flex-direction: column;
          "
        >
          <!-- Top Banner -->
          <div
            id="topBannerAreaBM"
            style="
              width: 100%;
              height: 221px;
              background: #d4ed31;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
            "
          >
            <span v-if="!banner" class="text-muted" style="font-size: 13px"
              >Top Banner (1920x150px)</span
            >
            <div
              id="topBannerOverlayBM"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 5;
              "
            >
              <img
                v-if="banner && banner.key === 'top' && banner.previewUrl"
                :src="banner.previewUrl"
                alt="Top Banner"
                style="width: 100%; height: 100%; object-fit: cover"
              />
            </div>
          </div>

          <!-- Ticker Bar -->
          <div
            style="
              background: #2c3e50;
              height: 32px;
              display: flex;
              align-items: center;
              padding: 0 15px;
              color: #fff;
              font-size: 12px;
              font-weight: bold;
            "
          >
            Ticker
          </div>

          <!-- Main Content Area -->
          <div style="display: flex; flex: 1">
            <!-- Nav Bar (Vertical - Left Side) -->
            <div
              style="
                width: 60px;
                background: #34495e;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
              "
            >
              <div
                style="
                  writing-mode: vertical-rl;
                  transform: rotate(180deg);
                  color: #fff;
                  font-weight: bold;
                  font-size: 1.1em;
                "
              >
                Nav Bar
              </div>
            </div>

            <!-- Center Content with Carousel -->
            <div
              style="
                flex: 1;
                padding: 15px;
                background: #f5f5f5;
                display: flex;
                flex-direction: column;
              "
            >
              <!-- Carousel Banner -->
              <div
                id="carouselAreaBM"
                style="
                  width: 100%;
                  height: 144px;
                  background: #e9ecef;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 15px;
                  position: relative;
                  border-radius: 4px;
                "
              >
                <span v-if="!banner" class="text-muted" style="font-size: 12px"
                  >Carousel Banner (1200x400px)</span
                >
                <div
                  id="carouselOverlayBM"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 5;
                    border-radius: 4px;
                    overflow: hidden;
                  "
                >
                  <img
                    v-if="
                      banner && banner.key === 'carousel' && banner.previewUrl
                    "
                    :src="banner.previewUrl"
                    alt="Carousel"
                    style="width: 100%; height: 100%; object-fit: cover"
                  />
                </div>
              </div>

              <!-- Main Content -->
              <div
                style="
                  background: #fff;
                  padding: 15px;
                  border-radius: 4px;
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <span
                  class="text-muted"
                  style="font-size: 12px"
                  id="mainContentText"
                  >Main Website Content (Logged Out View - Promotions, Sign Up
                  CTA)</span
                >
              </div>
            </div>

            <!-- Betslip (Right) -->
            <div
              style="
                width: 130px;
                background: #7db3e8;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="
                  writing-mode: vertical-rl;
                  transform: rotate(180deg);
                  font-weight: bold;
                  font-size: 1.2em;
                "
              >
                Betslip
              </div>
            </div>
          </div>
        </div>

        <!-- Right Sidebar (Outside - Gray Area) -->
        <div
          id="rightSidebarAreaBM"
          style="
            width: 16%;
            background: #b8c5d1;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          "
        >
          <span
            v-if="!banner"
            class="text-muted small text-center"
            style="
              writing-mode: vertical-rl;
              transform: rotate(180deg);
              font-size: 10px;
            "
            >Right Sidebar<br />300x600px</span
          >
          <div
            id="rightSidebarOverlayBM"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 5;
            "
          >
            <img
              v-if="banner && banner.key === 'right' && banner.previewUrl"
              :src="banner.previewUrl"
              alt="Right Sidebar"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>
        </div>
      </div>
      <div class="text-white small text-center mt-2">
        Upload banners to see them overlaid on the template
      </div>
    </div>
  </div>
</template>
<script>
import { arrayProp, stringProp } from "@/helpers/props";
export default {
  props: {
    banners: arrayProp(),
    bannerPosition: stringProp(),
  },
  watch: {
    bannerPosition(val) {
      this.banner = this.banners.find((banner) => banner.key === val);
    },
  },
  data() {
    return {
      banner: null,
    };
  },
};
</script>
